module.exports = '<svg width="20" height="32" viewBox="0 0 20 32"><path d="M8 14c-2.208 0-4-1.794-4-4s1.792-4 4-4h4a4.01 4.01 0 0 1 3.876 3.01c.136.534.572.99 1.124.99h2c.552 0 1.008-.452.938-.998C19.446 5.058 16.074 2 12 2V1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1c-4.41 0-8 3.588-8 8s3.59 8 8 8h4c2.208 0 4 1.794 4 4s-1.792 4-4 4H8a4.01 4.01 0 0 1-3.876-3.01C3.988 22.456 3.552 22 3 22H1c-.552 0-1.008.452-.938.998C.554 26.942 3.926 30 8 30v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1c4.41 0 8-3.588 8-8s-3.59-8-8-8H8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/money-2.js
// module id = 1286
// module chunks = 14